var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCc8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1161 36.7052H63.9115V38.8009H38.6392C40.336 50.726 27.5747 59.5583 16.9861 53.7488C16.1744 54.3401 15.3418 55.7203 14.3184 55.925C13.8409 56.0212 13.1061 55.813 12.7773 56.0859L7.6098 63.7496C3.10881 67.5876 -2.6202 61.7502 1.31401 57.3227L8.97776 52.1552C9.14045 51.6759 8.97601 51.1686 9.07398 50.6805C9.27865 49.6589 10.6589 48.8262 11.2501 48.0128C9.77195 45.1649 9.12645 42.0092 9.56903 38.8009H1.05861V36.7052H2.10645V25.9032C2.10645 25.4711 2.83942 25.2105 3.21377 25.1772C5.87798 24.9358 8.89904 25.3714 11.6035 25.1807C11.9254 25.1038 12.5831 25.6548 12.5831 25.9032V31.7302L14.6753 29.568V17.7829C14.684 17.3648 14.9429 17.0149 15.326 16.8627L24.0464 16.798C24.4854 16.7788 24.8545 16.9764 25.054 17.3613L25.1712 26.1481L25.3671 26.3458L27.2476 26.6257V7.04559C27.2476 6.6135 27.9806 6.35286 28.3549 6.31962C31.0191 6.07821 34.0402 6.51379 36.7446 6.32312C37.1627 6.33361 37.5126 6.59076 37.6648 6.97386L37.7173 35.2043L38.1161 36.7052ZM35.6286 8.42055H29.3433V27.2764C31.8553 28.0706 33.8705 29.8479 35.6286 31.7284V8.42055ZM23.058 18.8972H16.7727V28.1948C18.6427 27.1942 20.6929 26.4367 22.8411 26.3423L23.058 26.1656V18.8989V18.8972ZM10.4874 27.2764H4.20213V36.7035H10.0938C10.0606 36.4113 10.4874 35.7589 10.4874 35.5909V27.2764ZM22.9006 28.3627C13.2881 29.2654 8.15733 40.5345 13.9686 48.3469C19.2777 55.4841 30.1777 55.0923 34.8169 47.4828C40.2275 38.6085 33.1865 27.3989 22.9006 28.3645V28.3627ZM15.2018 52.4211C14.196 51.7983 13.2024 50.8065 12.5814 49.8006C12.1458 50.2782 10.846 51.0006 11.2676 51.7056C11.3691 51.8753 13.3161 53.7995 13.463 53.8398C13.9983 53.9902 14.838 52.7884 15.2018 52.4211ZM10.1918 53.8765L2.63125 59.03C0.852194 61.563 4.02195 64.2604 6.23484 62.1088L11.1242 54.8071C11.2029 54.4905 10.4944 53.8013 10.1918 53.8748V53.8765Z",
    fill: "#0F79E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8176 52.4176H59.7219V51.3698H55.5323V55.8865C55.5323 56.6737 53.9456 56.6177 53.4383 56.672L57.6927 62.1071L61.8176 56.672C60.0403 56.7017 59.5225 56.3711 59.7236 54.5116H64.2404C64.7424 54.5116 65.2445 55.6976 64.8106 56.1297L58.4116 64.6576C57.9813 65.1194 57.2571 65.1089 56.8425 64.6576L50.4435 56.1297C50.0097 55.6959 50.5135 54.5116 51.0138 54.5116H53.4366V49.9948C53.4366 49.5628 54.1696 49.3021 54.5439 49.2689C56.5766 49.0852 58.8927 49.4123 60.9586 49.2829C61.2385 49.2496 61.8176 49.7884 61.8176 49.9948V52.4176Z",
    fill: "#0F79E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1514 51.3697C46.952 49.5102 47.468 49.1796 49.2453 49.2093L45.1204 43.7742L40.8661 49.2093C41.3734 49.2635 42.96 49.2076 42.96 49.9947V54.5115H47.1496V53.4636H49.2453V55.8864C49.2453 56.0946 48.6663 56.6334 48.3864 56.5984C46.3205 56.469 44.0061 56.7961 41.9717 56.6124C41.5973 56.5792 40.8644 56.3185 40.8644 55.8864V51.3697H38.4416C37.9395 51.3697 37.4374 50.1837 37.8713 49.7516L44.2143 41.2989C44.7741 40.7846 45.3304 40.7811 45.8936 41.2989L52.2367 49.7516C52.6705 50.1854 52.1667 51.3697 51.6664 51.3697H47.1496H47.1514Z",
    fill: "#0F79E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9139 6.19556H39.8182V8.29124H41.9139V6.19556Z",
    fill: "#0F79E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2949 6.19556H48.1992V8.29124H50.2949V6.19556Z",
    fill: "#0F79E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9139 18.3726H39.8182V20.4682H41.9139V18.3726Z",
    fill: "#0F79E3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2949 18.3726H48.1992V20.4682H50.2949V18.3726Z",
    fill: "#0F79E3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2949 9.20605H48.1992V11.3017H50.2949V9.20605Z",
    fill: "#0F79E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9139 9.20605H39.8182V11.3017H41.9139V9.20605Z",
    fill: "#0F79E3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2949 30.5513H48.1992V32.647H50.2949V30.5513Z",
    fill: "#0F79E3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9139 30.5513H39.8182V32.647H41.9139V30.5513Z",
    fill: "#0F79E3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2949 27.5388H48.1992V29.6345H50.2949V27.5388Z",
    fill: "#0F79E3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9139 27.5388H39.8182V29.6345H41.9139V27.5388Z",
    fill: "#0F79E3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4844 25.1826V27.2783H52.3888C52.1858 25.501 52.7071 24.9797 54.4844 25.1826Z",
    fill: "#0F79E3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2931 2.13529H48.1974V0.0413641C49.9729 -0.161556 50.496 0.35799 50.2931 2.13704V2.13529Z",
    fill: "#0F79E3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9139 0.0412829V2.13696H39.8182C39.6153 0.359658 40.1366 -0.161638 41.9139 0.0412829Z",
    fill: "#0F79E3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8637 27.2764H60.7681V25.1808C62.5436 24.9778 63.0667 25.4974 62.8637 27.2764Z",
    fill: "#0F79E3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9139 12.3496H39.8182V14.3141H41.9139V12.3496Z",
    fill: "#0F79E3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4844 28.1931H52.3887V30.1576H54.4844V28.1931Z",
    fill: "#0F79E3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2949 12.3496H48.1992V14.3141H50.2949V12.3496Z",
    fill: "#0F79E3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2949 3.18311H48.1992V5.14759H50.2949V3.18311Z",
    fill: "#0F79E3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2949 24.5266H48.1992V26.4911H50.2949V24.5266Z",
    fill: "#0F79E3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9139 33.6929H39.8182V35.6574H41.9139V33.6929Z",
    fill: "#0F79E3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2949 33.6929H48.1992V35.6574H50.2949V33.6929Z",
    fill: "#0F79E3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4844 33.8242H52.3887V35.7887H54.4844V33.8242Z",
    fill: "#0F79E3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8655 33.8242H60.7698V35.7887H62.8655V33.8242Z",
    fill: "#0F79E3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9139 24.5266H39.8182V26.4911H41.9139V24.5266Z",
    fill: "#0F79E3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2949 21.5159H48.1992V23.4803H50.2949V21.5159Z",
    fill: "#0F79E3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9139 21.5159H39.8182V23.4803H41.9139V21.5159Z",
    fill: "#0F79E3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2949 15.3618H48.1992V17.3263H50.2949V15.3618Z",
    fill: "#0F79E3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9139 3.18311H39.8182V5.14759H41.9139V3.18311Z",
    fill: "#0F79E3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9139 15.3618H39.8182V17.3263H41.9139V15.3618Z",
    fill: "#0F79E3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8655 28.1931H60.7698V30.1576H62.8655V28.1931Z",
    fill: "#0F79E3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8532 25.1826H58.0199V27.2783H59.8532V25.1826Z",
    fill: "#0F79E3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2344 25.1826H55.4011V27.2783H57.2344V25.1826Z",
    fill: "#0F79E3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2825 0.0412598H45.4492V2.13694H47.2825V0.0412598Z",
    fill: "#0F79E3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6638 0.0412598H42.8306V2.13694H44.6638V0.0412598Z",
    fill: "#0F79E3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4844 31.0742H52.3887V32.9075H54.4844V31.0742Z",
    fill: "#0F79E3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8655 31.0742H60.7698V32.9075H62.8655V31.0742Z",
    fill: "#0F79E3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0301 30.4586C32.172 29.5682 38.0794 40.1358 32.3522 47.3744C28.145 52.6924 20.0667 52.6924 15.8579 47.3744C10.7656 40.9387 14.8957 31.251 23.0301 30.4586ZM23.1613 32.5525C12.4992 33.6406 13.8077 50.1156 24.8231 49.2724C35.7161 48.438 34.5143 31.3944 23.1613 32.5525Z",
    fill: "#0F79E3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1537 44.0367H23.0581C23.0283 43.246 23.0056 42.5497 23.4237 41.8483C24.1269 40.671 25.7887 40.8407 26.1439 39.331C26.8576 36.2959 22.0837 35.6312 22.0102 38.7975H19.9145C19.8883 35.8219 22.8149 33.8381 25.5928 34.886C28.3497 35.9251 29.2034 39.5077 27.1847 41.6803C26.31 42.6215 24.8126 42.5025 25.152 44.0349L25.1537 44.0367Z",
    fill: "#0F79E3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1537 45.0845H23.058V47.1801H25.1537V45.0845Z",
    fill: "#0F79E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc8);
export default __webpack_public_path__ + "static/media/cc-8.300af46f547e0df19bb66a614cfe5cd9.svg";
export { ForwardRef as ReactComponent };